import { Car, Inquiry, FuelType, BodyType } from "./types";

export const mockCars: Car[] = [
  {
    id: "1", slug: "skoda-octavia-2-0-tdi-style",
    brand: "Škoda", model: "Octavia", variant: "2.0 TDI Style DSG",
    price_monthly: 9990, duration_months: 36, km_per_year: 15000,
    fuel: "nafta", transmission: "automat", body: "kombi",
    power_kw: 110, in_stock: true, is_electric: false,
    is_new: true, flexi: false, four_by_four: false,
    navigation: true, tow_bar: true, warranty_included: true, tyres_included: false,
    targets: ["firmy", "podnikatele", "soukrome"],
    year: 2024, color: "Magnetická šedá", doors: 5, down_payment: 0,
    partner: { name: "AutoGroup CZ", id: "autocz", description: "Největší dealer vozidel skupiny Volkswagen v ČR s 15 lety zkušeností." },
  },
  {
    id: "2", slug: "vw-tiguan-1-5-tsi-life",
    brand: "Volkswagen", model: "Tiguan", variant: "1.5 TSI Life",
    price_monthly: 12490, duration_months: 48, km_per_year: 10000,
    fuel: "benzin", transmission: "automat", body: "suv",
    power_kw: 110, in_stock: true, is_electric: false,
    is_new: true, flexi: true, four_by_four: false,
    navigation: true, tow_bar: false, warranty_included: true, tyres_included: true,
    targets: ["firmy", "soukrome"],
    year: 2024, color: "Bílá stříbrná", doors: 5, down_payment: 0,
    partner: { name: "AutoGroup CZ", id: "autocz", description: "Největší dealer vozidel skupiny Volkswagen v ČR s 15 lety zkušeností." },
  },
  {
    id: "3", slug: "tesla-model-3-standard-range",
    brand: "Tesla", model: "Model 3", variant: "Standard Range RWD",
    price_monthly: 13990, duration_months: 36, km_per_year: 10000,
    fuel: "elektro", transmission: "automat", body: "sedan",
    power_kw: 208, in_stock: true, is_electric: true,
    is_new: true, flexi: true, four_by_four: false,
    navigation: true, tow_bar: false, warranty_included: true, tyres_included: false,
    targets: ["firmy", "podnikatele", "soukrome"],
    year: 2024, color: "Pearl White", doors: 4, down_payment: 0,
    partner: { name: "EV Česko", id: "evcz", description: "Specialisté na elektrická vozidla. Kompletní servis a poradenství pro přechod na elektromobilitu." },
  },
  {
    id: "4", slug: "bmw-x3-20d-xdrive",
    brand: "BMW", model: "X3", variant: "xDrive20d Advantage",
    price_monthly: 17990, duration_months: 36, km_per_year: 15000,
    fuel: "nafta", transmission: "automat", body: "suv",
    power_kw: 140, in_stock: false, is_electric: false,
    is_new: true, flexi: false, four_by_four: true,
    navigation: true, tow_bar: true, warranty_included: true, tyres_included: true,
    targets: ["firmy", "podnikatele"],
    year: 2024, color: "Sopková šedá", doors: 5, down_payment: 50000,
    partner: { name: "Premium Cars CZ", id: "premiumcz", description: "Autorizovaný dealer prémiových značek BMW, Mercedes-Benz a Škoda." },
  },
  {
    id: "5", slug: "hyundai-tucson-1-6-tgdi-hybrid",
    brand: "Hyundai", model: "Tucson", variant: "1.6 T-GDi Hybrid 4WD",
    price_monthly: 11790, duration_months: 48, km_per_year: 20000,
    fuel: "hybrid", transmission: "automat", body: "crossover",
    power_kw: 169, in_stock: true, is_electric: false,
    is_new: true, flexi: true, four_by_four: true,
    navigation: true, tow_bar: true, warranty_included: true, tyres_included: false,
    targets: ["firmy", "podnikatele", "soukrome"],
    year: 2024, color: "Phantom Black", doors: 5, down_payment: 0,
    partner: { name: "AutoGroup CZ", id: "autocz", description: "Největší dealer vozidel skupiny Volkswagen v ČR s 15 lety zkušeností." },
  },
  {
    id: "6", slug: "skoda-kodiaq-2-0-tsi-rs",
    brand: "Škoda", model: "Kodiaq", variant: "2.0 TSI RS 4x4 DSG",
    price_monthly: 19990, duration_months: 36, km_per_year: 15000,
    fuel: "benzin", transmission: "automat", body: "suv",
    power_kw: 195, in_stock: true, is_electric: false,
    is_new: true, flexi: false, four_by_four: true,
    navigation: true, tow_bar: true, warranty_included: false, tyres_included: false,
    targets: ["firmy", "soukrome"],
    year: 2024, color: "Magic Black", doors: 5, down_payment: 30000,
    partner: { name: "Premium Cars CZ", id: "premiumcz", description: "Autorizovaný dealer prémiových značek BMW, Mercedes-Benz a Škoda." },
  },
  {
    id: "7", slug: "peugeot-e-208-active",
    brand: "Peugeot", model: "e-208", variant: "Active Pack 100kW",
    price_monthly: 8990, duration_months: 24, km_per_year: 10000,
    fuel: "elektro", transmission: "automat", body: "hatchback",
    power_kw: 100, in_stock: false, is_electric: true,
    is_new: false, flexi: true, four_by_four: false,
    navigation: false, tow_bar: false, warranty_included: true, tyres_included: true,
    targets: ["soukrome", "podnikatele"],
    year: 2023, color: "Elixir Red", doors: 5, down_payment: 0,
    partner: { name: "EV Česko", id: "evcz", description: "Specialisté na elektrická vozidla. Kompletní servis a poradenství pro přechod na elektromobilitu." },
  },
  {
    id: "8", slug: "mercedes-cla-200-progressive",
    brand: "Mercedes-Benz", model: "CLA", variant: "200 Progressive Line",
    price_monthly: 15990, duration_months: 36, km_per_year: 10000,
    fuel: "benzin", transmission: "automat", body: "sedan",
    power_kw: 120, in_stock: true, is_electric: false,
    is_new: true, flexi: false, four_by_four: false,
    navigation: true, tow_bar: false, warranty_included: false, tyres_included: false,
    targets: ["firmy", "soukrome"],
    year: 2024, color: "Polární bílá", doors: 4, down_payment: 20000,
    partner: { name: "Premium Cars CZ", id: "premiumcz", description: "Autorizovaný dealer prémiových značek BMW, Mercedes-Benz a Škoda." },
  },
];

export const mockInquiries: Inquiry[] = [
  { id: "1", customer_name: "Jan Novák", car_name: "Škoda Octavia 2.0 TDI", date: "2026-05-25", status: "nova" },
  { id: "2", customer_name: "Marie Svobodová", car_name: "VW Tiguan 1.5 TSI", date: "2026-05-25", status: "kontaktovan" },
  { id: "3", customer_name: "Petr Dvořák", car_name: "BMW X3 xDrive20d", date: "2026-05-24", status: "uzavreno" },
  { id: "4", customer_name: "Eva Horáková", car_name: "Tesla Model 3", date: "2026-05-24", status: "nova" },
  { id: "5", customer_name: "Tomáš Procházka", car_name: "Hyundai Tucson Hybrid", date: "2026-05-23", status: "kontaktovan" },
];

export const BRANDS = ["Škoda", "Volkswagen", "Tesla", "BMW", "Hyundai", "Peugeot", "Mercedes-Benz"];

export const FUEL_OPTIONS: { value: FuelType; label: string }[] = [
  { value: "benzin", label: "Benzín" },
  { value: "nafta", label: "Nafta" },
  { value: "cng", label: "CNG" },
  { value: "elektro", label: "Elektro" },
  { value: "hybrid", label: "Hybrid" },
  { value: "lpg", label: "LPG" },
];

export const BODY_OPTIONS: { value: BodyType; label: string }[] = [
  { value: "kombi", label: "Kombi" },
  { value: "crossover", label: "Crossover" },
  { value: "dodavka", label: "Dodávka" },
  { value: "hatchback", label: "Hatchback / Liftback" },
  { value: "kabriolet", label: "Kabriolet" },
  { value: "kupe", label: "Kupé" },
  { value: "minibus", label: "Minibus" },
  { value: "mpv", label: "MPV - Rodinný vůz" },
  { value: "offroad", label: "Off-road" },
  { value: "pickup", label: "Pick-up" },
  { value: "sedan", label: "Sedan" },
  { value: "suv", label: "SUV" },
];

export const DURATIONS = [24, 36, 48];
export const PRICE_MIN = 2500;
export const PRICE_MAX = 100000;
export const KM_MIN = 5000;
export const KM_MAX = 50000;
export const DURATION_MAX_LIMIT = 60;

export function formatPrice(price: number): string {
  return price.toLocaleString("cs-CZ").replace(/,/g, " ");
}

export function fuelLabel(fuel: string): string {
  const found = FUEL_OPTIONS.find((f) => f.value === fuel);
  return found?.label ?? fuel;
}

export function bodyLabel(body: string): string {
  const found = BODY_OPTIONS.find((b) => b.value === body);
  return found?.label ?? body;
}
